import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { css } from 'design'
import { cn } from 'util/cn'

import { useNavAndClearSelected } from '../../../../hooks/app_location/use_nav_and_clear_selected'
import { makeGetCall } from '../../../../reduxes/slices/api/selectors'
import { getCurrentAccount } from '../../../../reduxes/slices/current/selectors'
import { getRoutes } from '../../../../reduxes/slices/routes/selectors'
import { useSelectorDelegateStore } from '../../../../reduxes/stores/root_store/hooks'
import { TimelineType } from '../../../../types/models'
import Call from './call'

export const CallContainer = ({
  timeline,
  ...props
}: {
  timeline: TimelineType
}) => {
  const getCall = useMemo(makeGetCall, [])
  // eslint-disable-next-line
  // @ts-ignore
  const call = useSelector((state) => getCall(state, timeline?.tl_id))
  const [showUpgradeMessage, setShowUpgradeMessage] = useState(false)
  const currentAccount = useSelector(getCurrentAccount)
  const routes: any = useSelectorDelegateStore(getRoutes)
  const navAndClearSelected = useNavAndClearSelected()

  useEffect(() => {
    if (
      call?.end_time &&
      call?.limit_state === 'exceeded' &&
      currentAccount.plan !== 'paid'
    ) {
      // eslint-disable-next-line
      // @ts-ignore
      const secondsSinceEndTime = (new Date() - new Date(call.end_time)) / 1000
      if (secondsSinceEndTime < 5 * 60) {
        setShowUpgradeMessage(true)

        setTimeout(() => {
          setShowUpgradeMessage(false)
        }, (5 * 60 - secondsSinceEndTime) * 1000)
      }
    }
  }, [call?.end_time, call?.limit_state, currentAccount.plan])

  const goToPlans = useCallback(() => {
    navAndClearSelected(routes.admin_app_billing.path)
  }, [routes.admin_app_billing.path, navAndClearSelected])

  return (
    <>
      <Call call={call} timeline={timeline} {...props} />
      {showUpgradeMessage && (
        <section className={'timeline'}>
          <div className={'main-row'}>
            <div className={'timeline__status__line'} />
            <div className={cn('content', contentStyles())}>
              <span>Upgrade to unlimited calling</span>
              <button onClick={goToPlans}>View plans</button>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

const contentStyles = css({
  flexDirection: 'row !important',
  alignItems: 'center !important',
  color: '$grey700',

  button: {
    marginLeft: '$3',
    borderRadius: '5px',
    border: 'none',
    fontWeight: '600',
    padding: '$1 $2',
    cursor: 'pointer',
  },
})
